import ContratoInterceptor from '../ContratoInterceptor'
import { TabelaReferencia } from '../../../types/Contratos'

const api = new ContratoInterceptor()

export default {
  createTabelaReferenciaGrupoRemuneracao(grupoRemuneracaoId: String, contratoId: String, tabelaReferencia: TabelaReferencia) {
    return api.post(`/contratos/${contratoId}/grupos-remuneracao/${grupoRemuneracaoId}/tabelas-referencias`, tabelaReferencia)
  },

  getTabelasReferencias() {
    return api.get(`/tabelas-referencia`)
  },

  getTabelasReferenciasGrupoRemuneracao(grupoRemuneracaoId: String) {
    return api.get(`/contratos/grupos-remuneracao/${grupoRemuneracaoId}/tabelas-referencias`)
  },
}
